import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  TimeconversionService,
  ToastMessageService,
} from '@fitness-force/api';
import {
  ClientInteraction,
  ClientById,
  STAFFINTERFACE,
} from '@fitness-force/models';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { CommunicationDirection } from 'libs/enum/src/lib/enum.common';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject, map, Observable, shareReplay, forkJoin, of } from 'rxjs';
import { ShortNamePipe } from 'libs/pipes/short-name/src/lib/name-initials.pipe';
import { CONSTANTS_CRM } from 'libs/constants/src/lib/constants.crm';
import Statsig from 'statsig-js';
import { StaffStoreService } from 'libs/api/src/lib/staff/staff-store.service';

@Component({
  selector: 'conversation-logs',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ScrollPanelModule,
    DividerModule,
    AvatarModule,
    SelectModule,
    EditorModule,
    ButtonModule,
    SkeletonModule,
    DateTimeFormatPipe,
    ShortNamePipe,
    TranslateModule,
    TooltipModule
  ],
  templateUrl: './conversation-logs.component.html',
})
export class ConversationLogsComponent implements OnInit, OnChanges, AfterViewInit {
  @Input('clientId') clientId: number = 0;
  @Input('tenantId') tenantId: number = 0;
  @Input('interactions') Interactions : ClientInteraction[] = [];
  @Input('clientDetails') client: ClientById = {} as ClientById;
  @Input('showSkeleton') showSkeleton: boolean = true;
  @Input('styleClass') styleClass: string = "mt-3 text-xs relative h-full";
  @Input('height') height: string = "40vh";
  @Input('interactionId') interactionId: number = 0;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;

  conversations = new BehaviorSubject<ClientInteraction[]>([]);
  groupedConversations = new BehaviorSubject<any[]>([]);
  showConversation: boolean = true;
  showWhatsapp: boolean = true;
  editorText: string | undefined;
  replies: any[];
  selectedReply: { name: string; icon: string; color: string } | undefined;
  showClientProfile: boolean = true;
  whatsAppFilter: boolean = true;
  getStaffList$: Observable<any> | any;
  callOutcome: any[];
  tourOutcome: any[];
  lastInteraction :ClientInteraction;
  highlightedActivities: Set<number> = new Set();
  isTwoWayNotificationEnabled: boolean = false;
  showDotColor: string = 'text-red-500';
  private staffDetailsCache: Map<number, Observable<STAFFINTERFACE>> = new Map();

  constructor(
    private timeService: TimeconversionService,
    private store: Store,
    public translate: TranslateService,
    public cd: ChangeDetectorRef,
    public toastMessageService: ToastMessageService,
    private staffStoreService: StaffStoreService
  ) {
  }

  ngOnInit(): void {
    this.isTwoWayNotificationEnabled = Statsig.checkGate("show_staff_2way_message_notifciation");
    //this.GetStaffs();
    this.translateOutComeOption();
    this.componentInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to the selectedOption input
    if (
      changes.Interactions &&
      changes.Interactions.currentValue != changes.Interactions.previousValue
    ) {
      this.conversations.next(changes.Interactions.currentValue);
      this.conversations.subscribe((data) => {
        this.groupedConversations.next(this.groupMessagesByDate(data));
        // Pre-fetch staff details when conversations change
        this.prefetchStaffDetails(data);
      });
      if(this.interactionId > 0)
      {
        this.highlightedActivities.add(this.interactionId);
        setTimeout(() => {
          this.highlightedActivities.delete(this.interactionId);
        }, 5000);
      }
      }
      this.scrollToBottom();
    }

    componentInit()
    {
      this.conversations.next(this.Interactions);
      this.conversations.subscribe((data) => {
        this.groupedConversations.next(this.groupMessagesByDate(data));
        // Pre-fetch staff details when component initializes
        this.prefetchStaffDetails(data);
      });
      if(this.interactionId > 0)
      {
        this.highlightedActivities.add(this.interactionId);
        setTimeout(() => {
          this.highlightedActivities.delete(this.interactionId);
        }, 5000);
      } 
      
      this.cd.detectChanges();
    }

  /**
   * Pre-fetches staff details for all staff members in the conversation
   * This reduces API calls by loading all required staff details at once
   */
  prefetchStaffDetails(interactions: ClientInteraction[]) {
    if (!interactions || interactions.length === 0) return;
    
    // Get unique staff IDs from all interactions
    const staffIds = new Set<number>();
    interactions.forEach(interaction => {
      const staffId = interaction.staff_id || interaction.updated_by;
      if (staffId && !this.staffDetailsCache.has(staffId)) {
        staffIds.add(staffId);
      }
    });
    
    // Pre-fetch all staff details if not already in cache
    if (staffIds.size > 0) {
      const requests: Observable<STAFFINTERFACE>[] = [];
      staffIds.forEach(id => {
        const request = this.staffStoreService.getStaffById(id).pipe(
          shareReplay(1)
        );
        this.staffDetailsCache.set(id, request);
        requests.push(request);
      });
      
      // Execute all requests in parallel
      forkJoin(requests).subscribe();
    }
  }

  GetStaffs() {
    // this.store.select(STAFF_STATE).subscribe((data: any) => {
    //   if (data && data.staffListAll && data.staffListAll.length > 0) {
    //     this.getStaffList$ = data.staffListAll;
    //   }
    // });
  }

  groupMessagesByDate(
    messages: ClientInteraction[]
  ): { date: string; messages: any[] }[] {
    try {
      if (!messages || messages.length === 0) {
        return [];
      }
  
      const grouped = new Map<string, ClientInteraction[]>();
  
      messages.forEach((message) => {
        if (!message.log_date) {
          console.warn('Message without log_date found:', message);
          return;
        }
  
        let logDate = this.timeService.ConvertUTCToLocalDateTime(
          message.log_date
        );
        logDate.setHours(0, 0, 0, 0);
        const messageDate = logDate.toDateString();
  
        if (!grouped.has(messageDate)) {
          grouped.set(messageDate, []);
        }
  
        const messagesForDate = grouped.get(messageDate);
        if (messagesForDate) {
          messagesForDate.push(message);
        }
      });
      
      const sortedGrouped = Array.from(grouped.entries()).map(([date, messages]) => ({
        date,
        messages: messages.sort((a, b) => 
          new Date(a.log_date).getTime() - new Date(b.log_date).getTime()
        )
      }));
  
      // return this.isTwoWayNotificationEnabled
      //   ? sortedGrouped.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
      //   : sortedGrouped.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        return sortedGrouped.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  
    } catch (error) {
      console.error('Error in groupMessagesByDate:', error);
      return [];
    }
  }

  getSortedConversations(conversations: ClientInteraction[]) {
    this.lastInteraction =conversations.sort((a, b) =>new Date(a.log_date).getTime() - new Date(b.log_date).getTime())[conversations.length-1];

    if(this.isTwoWayNotificationEnabled)
    {
      return conversations.sort(
        (a, b) =>
          new Date(a.log_date).getTime() - new Date(b.log_date).getTime()
      );
    }
    else
    {
      return conversations.sort(
        (a, b) =>
          new Date(b.log_date).getTime() - new Date(a.log_date).getTime()
      );
    }
    // return conversations.sort(
    //   (a, b) =>
    //     new Date(a.log_date).getTime() - new Date(b.log_date).getTime()
    // );
  }

  hasRecentIncomingWhatsApp(): void {
    try {
      const interactions = this.Interactions;
      if (!interactions || interactions.length === 0) {
        this.showDotColor = 'text-red-500';
        return;
      }
      const currentTime = new Date();

      const whatsappInteractions = interactions.filter(interaction => 
        interaction.interaction_type?.toLowerCase() == 'whatsapp' && 
        (interaction.direction == CommunicationDirection.Incoming || 
         interaction.direction.toString() == CommunicationDirection[CommunicationDirection.Incoming])
      );

      const isActive = whatsappInteractions.some(interaction => {
        // Get interaction time and calculate difference
        const interactionTime = this.timeService.ConvertUTCToLocalDateTime(interaction.log_date);
        const hoursDifference = (currentTime.getTime() - interactionTime.getTime()) / (1000 * 60 * 60);
        return hoursDifference < 24;
      });
      
      this.showDotColor = isActive ? 'text-green-500' : 'text-red-500';
    } catch (error) {
      console.error('Error checking for recent incoming WhatsApp:', error);
    }
  }

  getStaffDetails(staffId: number) {
    if (!staffId) return of(null);
    
    if (!this.staffDetailsCache.has(staffId)) {
      this.staffDetailsCache.set(
        staffId,
        this.staffStoreService.getStaffById(staffId).pipe(shareReplay(1))
      );
    }
    return this.staffDetailsCache.get(staffId);
  }

 

  showHighlightedMsg(interaction: ClientInteraction)
  {
    return this.highlightedActivities.has(interaction.interaction_id);
    //return this.interactionId == interaction.interaction_id;
  }

  hideHighlitedMsg(){
    setTimeout(() => {
      return true;
    },5000);
  }

  scrollToHighlighted(): void {
    const highlightedElement = this.scrollContainer.nativeElement.querySelector('.bg-yellow-200.px-5.py-3');
    if (highlightedElement) {
      highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  getIcons(type: string) {
    if (type.toLowerCase() === 'email') {
      return 'fa fa-envelope';
    } else if (type.toLowerCase() === 'sms') {
      return 'fa fa-comment';
    } else if (type.toLowerCase() === 'call') {
      return 'fa fa-phone-slash';
    } else if (type.toLowerCase() === 'whatsapp') {
      return 'fab fa-whatsapp';
    } else {
      return '';
    }
  }

  getClass(type: string) {
    if (type.toLowerCase() === 'email') {
      return 'bg-orange-500';
    } else if (type.toLowerCase() === 'sms') {
      return 'bg-pink-500';
    } else if (type.toLowerCase() === 'call') {
      return 'surface-900';
    } else if (type.toLowerCase() === 'whatsapp') {
      return 'whatsapp-bg';
    } else {
      return '';
    }
  }

  getInteractionContent(interaction: ClientInteraction) {
    if (interaction.interaction_type.toLowerCase() === 'email') {
      {
        if(interaction.direction == CommunicationDirection.Incoming || interaction.direction.toString() == CommunicationDirection[CommunicationDirection.Incoming])
        {
          return this.getInteractionContentOptimised(interaction.body);
        }
        else
        {
          return interaction.body;
        }
      }
    } else if (interaction.interaction_type.toLowerCase() === 'sms') {
      return interaction.sms_content;
    } else if (interaction.interaction_type.toLowerCase() === 'call') {
      return interaction.notes;
    } else if (interaction.interaction_type.toLowerCase() === 'whatsapp') {
      //return interaction.sms_content ? interaction.sms_content : interaction.notes;
      if(interaction.whatsapp_content) {
        return interaction.whatsapp_content;
      } else {
        const staffId = interaction.staff_id ? interaction.staff_id : interaction.updated_by;
        return this.translate.instant('CLIENT_INTERACTION.NEW_WHATSAPP_SENT') + 
               `<strong class="text-primary"> Staff #${staffId}</strong>`;
      }
    } else {
      return '';
    }
  }

  translateOutComeOption(): void {
    this.callOutcome = CONSTANTS_CRM.CALL_OUTCOME;
    this.tourOutcome = CONSTANTS_CRM.TOUR_OUTCOME;
    this.translate
      .get([
        'OUTCOME.CALLOUTCOME.NO_ANSWER_LEFT_MESSAGE',
        'OUTCOME.CALLOUTCOME.CONTACT_MADE',
        'OUTCOME.CALLOUTCOME.NOT_INTERESTED',
        'OUTCOME.CALLOUTCOME.BOOK_TOUR',
        'OUTCOME.CALLOUTCOME.SIGN_UP',
      ])
      .subscribe((translation) => {
        this.callOutcome.forEach((obj: any) => {
          switch (String(obj.shortname).toLowerCase()) {
            case 'noanswer':
              obj.name =
                translation['OUTCOME.CALLOUTCOME.NO_ANSWER_LEFT_MESSAGE'];
              break;
            case 'contactmade':
              obj.name = translation['OUTCOME.CALLOUTCOME.CONTACT_MADE'];
              break;
            case 'notintrested':
              obj.name = translation['OUTCOME.CALLOUTCOME.NOT_INTERESTED'];
              break;
            case 'booktour':
              obj.name = translation['OUTCOME.CALLOUTCOME.BOOK_TOUR'];
              break;
            case 'signup':
              obj.name = translation['OUTCOME.CALLOUTCOME.SIGN_UP'];
              break;
            default:
              break;
          }
        });
      });
  }

  getCallOutcome(outcome: any) {
    if (outcome.toLowerCase() == 'noanswer_leftmessage')
      return this.callOutcome.find((c) => c.shortname == 'noanswer');
    if (outcome.toLowerCase() == 'notinterested')
      return this.callOutcome.find((c) => c.shortname == 'notintrested');
    else
      return this.callOutcome.find(
        (c) => c.shortname.toLowerCase() == outcome.toLowerCase()
      );
  }

  getTourOutcome(outcome: any) {
    if (outcome.toLowerCase() == 'notinterested')
      return this.callOutcome.find((c) => c.shortname == 'notintrested');
    return this.tourOutcome.find(
      (c) => c.shortname.toLowerCase() == outcome.toLowerCase()
    );
  }

  getNewInteraction(event: any) {
    this.conversations.next([...this.conversations.value, event]);
    this.conversations.subscribe((data) => {
      this.groupedConversations.next(this.groupMessagesByDate(data));
    });
    this.scrollToBottom();
    this.cd.detectChanges();
  }

  scrollToBottom(): void {
    try {
      setTimeout(() => {
        const messages = document.querySelectorAll('.conversation-message');
        if (messages && messages.length > 0) {
          const lastMessage = messages[messages.length - 1];
          lastMessage.scrollIntoView({ behavior: 'instant', block: 'nearest' });
        }
      },500);
    } catch(err) {
      console.error('Error scrolling to bottom:', err);
    }
  }

  public get directionEnum() {
    return CommunicationDirection;
  }

  getInteractionContentOptimised(message: string): string {
    if (!message) return '';
  
    try {
      // Split at hidden content marker
      const hiddenContentMarker = '-- Hidden Content Begins --';
      const parts = message.split(hiddenContentMarker);
      
      // Get the main content (part before hidden content)
      let mainContent = parts[0].trim();

      if(mainContent == '' || mainContent == null)
      {
        mainContent = parts[1].trim();
      }
      // Remove email signature block (everything after first occurrence of multiple newlines)
      const signaturePattern = /\n\s*(?:thankyou|regards|best|sincerely|yours|warm|thanks|--)/i;
      const signatureMatch = mainContent.match(signaturePattern);
      

      if (signatureMatch) {
        mainContent = mainContent.substring(0, signatureMatch.index).trim();
      }
  
      // Clean up the content
      return this.cleanupMessageContent(mainContent);
  
    } catch (error) {
      console.error('Error parsing message:', error);
      return message;
    }
  }
  
  private cleanupMessageContent(content: string): string {
    return content
      // Remove email headers
      .replace(/^(?:From|To|Sent|Date|Subject):.+$/gm, '')
      
      // Remove quoted text
      .replace(/^>.*$/gm, '')
      
      // Remove email signatures
      .replace(/^--\s*$/m, '')
      
      // Remove links
      .replace(/<https?:\/\/[^>]+>/g, '')
      
      // Remove asterisks (often used for formatting)
      .replace(/\*([^*]+)\*/g, '$1')
      
      // Remove contact info blocks
      .replace(/(?:Mobile|Phone|Tel|Email|Website|Address):\s*[^\n]+\n?/g, '')
      
      // Remove disclaimer text
      .replace(/IMPORTANT:[\s\S]*?(?=\n\n|$)/, '')
      
      // Remove excessive whitespace and newlines
      .replace(/\n{3,}/g, '\n\n')
      .replace(/\s+/g, ' ')
      
      // Final cleanup
      .trim();
  }

  ngAfterViewInit(): void {
    this.hasRecentIncomingWhatsApp();
  }

  /**
   * Get status icon class based on interaction type and status
   */
  getStatusIcon(interaction: ClientInteraction): string {
    const type = interaction.interaction_type?.toLowerCase();
    let status = '';
    
    if (type === 'email') {
      status = interaction.email_status?.toLowerCase() || '';
    } else if (type === 'sms') {
      status = interaction.sms_status?.toLowerCase() || '';
    } else if (type === 'whatsapp') {
      status = interaction.whatsapp_status?.toLowerCase() || '';
    }

    // Return appropriate icon based on status
    switch (status) {
      case 'sent':
      case 'accepted':
        return 'fa fa-check text-500';
      case 'delivered':
        return 'fa fa-check-double text-500';
      case 'read':
        return 'fa fa-check-double text-green-500';
      case 'failed':
      case 'error':
      case 'bounced':
        return 'fa fa-times text-red-500';
      default:
        return '';
    }
  }

  /**
   * Get tooltip text for status icon
   */
  getStatusTooltip(interaction: ClientInteraction): string {
    const type = interaction.interaction_type?.toLowerCase();
    let status = '';
    let failureReason = '';
    
    if (type === 'email') {
      status = interaction.email_status?.toLowerCase() || '';
      failureReason = interaction.email_failure_reason || '';
    } else if (type === 'sms') {
      status = interaction.sms_status?.toLowerCase() || '';
      failureReason = interaction.sms_failure_reason || '';
    } else if (type === 'whatsapp') {
      status = interaction.whatsapp_status?.toLowerCase() || '';
      failureReason = interaction.whatsapp_failure_reason || '';
    }

    // Return tooltip text based on status
    switch (status) {
      case 'sent':
      case 'accepted':
        return '';
      case 'delivered':
        return '';
      case 'read':
        return '';
      case 'failed':
      case 'error':
      case 'bounced':
        return failureReason ? `Failed: ${failureReason}` : '';
      default:
        return '';
    }
  }

  /**
   * Check if interaction should show status indicator
   */
  shouldShowStatusIndicator(interaction: ClientInteraction): boolean {
    // Only show for outgoing messages
    if (interaction.direction !== CommunicationDirection.Outgoing && 
        interaction.direction?.toString() !== CommunicationDirection[CommunicationDirection.Outgoing]) {
      return false;
    }

    const type = interaction.interaction_type?.toLowerCase();
    
    // Check if we have status information for this interaction type
    if (type.toLowerCase() === 'email' && interaction.email_status) {
      return true;
    } else if (type.toLowerCase() === 'sms' && interaction.sms_status) {
      return true;
    } else if (type.toLowerCase() === 'whatsapp' && interaction.whatsapp_status) {
      return true;
    }
    
    return false;
  }
}
